import { addCardSuccess } from "./index";

// Gets all products from the user's cart
export const getStorageCart = (products, listProduct) => (dispatch) => {
  let dataProducts = [];
  // Checks cart for duplicate items
  const existingProduct = listProduct?.find(item => item.id === products.id);
  if (existingProduct) {
    dataProducts = listProduct.map(item => {
      if (item.id === products.id) {
        return { ...item, quantity: 1 };
      }
      return { ...item };
    });
  } else {
    dataProducts = [...listProduct, { ...products, quantity: 1 }];
  }
  dispatch(addCardSuccess(dataProducts));
};